<template>
  <div class="newdirect-wrap">
    <el-form :model="formData" :rules="rules" ref="ruleForm">
      <ul class="modal-form">
        <li class="form-item">
          <span class="form-label">地理位置：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.districtMode">
              <el-radio label="UNLIMIT">不限</el-radio>
              <el-radio label="CITY">指定地区</el-radio>
            </el-radio-group>
            <div class="region-select-wrap" v-if="formData.districtMode === 'CITY'">
              <el-form-item prop="geoLocations">
                <el-select v-model="formData.geoLocations.locationTypes" multiple style="width: 400px">
                  <div v-if="isIncludesWxSite">
                    <el-option label="最近一个月居住在该区域的人" value="LIVE_IN"> </el-option>
                  </div>
                  <div v-else>
                    <el-option label="当前或最近1~2天位置在该区域的人" value="RECENTLY_IN"> </el-option>
                    <el-option label="最近一个月去过这里的人" value="VISITED_IN"> </el-option>
                    <el-option label="最近一个月居住在该区域的人" value="LIVE_IN"> </el-option>
                    <el-option label="旅游或出差来到该区域的人，并且近一个月常住地不在此" value="TRAVEL_IN"> </el-option>
                  </div>
                </el-select>

                <div class="region-content">
                  <el-cascader
                    class="cascader-wrap"
                    filterable
                    v-model="formData.geoLocations.transFormRegions"
                    :options="regionOptions"
                    collapse-tags
                    ref="areaCascader"
                    @change="handlerExpand"
                    :props="{
                      multiple: true,
                      value: 'id',
                      label: 'name',
                      emitPath: false,
                    }"
                    clearable
                  ></el-cascader>
                </div>
              </el-form-item>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">年龄：</span>
          <div class="form-value" style="display: flex">
            <el-radio-group v-model="formData.ageMode">
              <el-radio label="UNLIMIT">不限</el-radio>
              <el-radio v-for="item in ageList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              <el-radio label="CUSTOM">自定义</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li style="margin-left: 114px;margin-bottom: 12px;margin-top: -8px" v-if="formData.ageMode === 'CUSTOM'">
          <div class="form-value" style="display: flex">
            <el-select v-model="formData.age.min" style="width: 100px">
              <el-option
                v-for="item in getAgeList(14, formData.age.max)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div style="margin: 8px 12px">~</div>
            <el-select v-model="formData.age.max" style="width: 100px">
              <el-option
                v-for="item in getAgeList(formData.age.min, 66)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">性别：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.gender">
              <el-radio label="GENDER_UNLIMITED">不限</el-radio>
              <el-radio label="MALE">男</el-radio>
              <el-radio label="FEMALE">女</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-if="promotedObjectType === 'APP_ANDROID'">
          <span class="form-label">应用安装：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.appInstallStatus">
              <el-radio label="UNLIMIT">不限</el-radio>
              <el-radio label="NOT_INSTALLED">未安装</el-radio>
              <el-radio label="INSTALLED">已安装</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-if="!isQQShop">
          <span class="form-label">操作系统版本：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.userOsMode">
              <el-radio label="UNLIMIT">不限</el-radio>
              <el-radio label="CUSTOM">自定义</el-radio>
            </el-radio-group>
            <div class="region-select-wrap" v-if="formData.userOsMode === 'CUSTOM'">
              <el-form-item>
                <el-select v-model="formData.userOs" multiple style="width: 400px" collapse-tags>
                  <div v-if="promotedObjectType === 'APP_ANDROID'">
                    <el-option v-for="item in androidVersionList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </div>
                  <div v-else>
                    <el-option v-for="item in iosVersionList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </div>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">排除已转化用户：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.excludedConvertedAudience.excludedDimension">
              <el-radio label="UNLIMIT">不限</el-radio>
              <el-radio label="CAMPAIGN" :disabled="draftAdset.placementType === 'AUTO'">同计划广告</el-radio>
              <el-radio label="UID" :disabled="draftAdset.placementType === 'AUTO'">同账户广告</el-radio>
              <el-radio label="BUSINESS_MANAGER" :disabled="draftAdset.placementType === 'AUTO'">同商务管家广告</el-radio>
              <el-radio label="COMPANY_ACCOUNT" :disabled="draftAdset.placementType === 'AUTO'">同主体广告</el-radio>
              <el-radio label="APP" :disabled="draftAdset.placementType === 'AUTO'">同应用</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li style="margin-left: 114px" v-if="formData.excludedConvertedAudience.excludedDimension !== 'UNLIMIT'">
          <span class="form-label"></span>
          <el-form-item prop="conversionBehaviorList">
            <div style="margin-top: -8px;margin-bottom: 8px">
              <el-checkbox :disabled="isCpmCustom" v-model="formData.isCustomTransAction">
                <el-tooltip class="item" effect="dark" content="系统自动依照当前广告选择的优化目标作为此定向的转化行为" placement="top">
                  <span>自定义转化行为</span>
                </el-tooltip>
              </el-checkbox>
            </div>
            <div style="margin-bottom: 8px" v-if="formData.isCustomTransAction">
              <el-select v-model="formData.excludedConvertedAudience.conversionBehaviorList">
                <el-option v-for="item of transferActionList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </el-form-item>
        </li>
        <!-- 广告版位选择QQ购物时，定向包联网方式不展示 -->
        <li
          class="form-item"
          v-if="
            !(
              draftAdset.placement &&
              draftAdset.placement.siteSet &&
              draftAdset.placement.siteSet.length === 1 &&
              draftAdset.placement.siteSet[0] === 'SITE_SET_QQSHOPPING'
            )
          "
        >
          <span class="form-label">联网方式：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('networkType')">
              <el-checkbox v-model="unNetworkType">不限</el-checkbox>
            </div>
            <el-checkbox-group v-model="formData.networkType">
              <el-checkbox label="WIFI">WiFi</el-checkbox>
              <el-checkbox label="NET_2G">2G</el-checkbox>
              <el-checkbox label="NET_3G">3G</el-checkbox>
              <el-checkbox label="NET_4G">4G</el-checkbox>
              <el-checkbox label="NET_5G">5G</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>
        <div v-if="draftAdset.placementType !== 'AUTO'">
          <li class="form-item">
            <span class="form-label">微信再营销 ：</span>
            <div class="form-value" style="display: flex">
              <div style="margin-right: 20px" @click="noSelect('wxReMarketingMode')">
                <el-checkbox v-model="unwxReMarketing">不限</el-checkbox>
              </div>
              <el-checkbox-group v-model="formData.wxReMarketingMode">
                <el-checkbox label="REMARKET">再营销</el-checkbox>
                <el-checkbox label="EXCLUDE_MARKET">排除营销</el-checkbox>
              </el-checkbox-group>
            </div>
          </li>
          <li style="margin-left: 114px;margin-bottom: 12px">
            <div class="form-value" v-if="formData.wxReMarketingMode.includes('REMARKET')">
              <div style="font-size: 13px;margin-top: -8px;margin-bottom: 4px;color:#606266">再营销</div>
              <el-checkbox-group v-model="formData.wechatAdBehavior.actions">
                <el-checkbox
                  :disabled="formData.wechatAdBehavior.excludedActions.includes('WECHAT_OFFICIAL_ACCOUNT_AD_LIKE')"
                  label="WECHAT_OFFICIAL_ACCOUNT_AD_LIKE"
                  >对微信公众号广告感兴趣</el-checkbox
                >
                <el-checkbox
                  :disabled="formData.wechatAdBehavior.excludedActions.includes('WECHAT_MOMENTS_AD_LIKE')"
                  label="WECHAT_MOMENTS_AD_LIKE"
                  >对微信朋友圈广告感兴趣</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div class="form-value" v-if="formData.wxReMarketingMode.includes('EXCLUDE_MARKET')">
              <div style="font-size: 13px;margin: 8px 0 4px 0x;color:#606266">排除营销</div>
              <el-checkbox-group v-model="formData.wechatAdBehavior.excludedActions">
                <el-checkbox
                  :disabled="formData.wechatAdBehavior.actions.includes('WECHAT_OFFICIAL_ACCOUNT_AD_LIKE')"
                  label="WECHAT_OFFICIAL_ACCOUNT_AD_LIKE"
                  >对微信公众号广告感兴趣</el-checkbox
                >
                <el-checkbox :disabled="formData.wechatAdBehavior.actions.includes('WECHAT_MOMENTS_AD_LIKE')" label="WECHAT_MOMENTS_AD_LIKE"
                  >对微信朋友圈广告感兴趣</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </li>
        </div>

        <li class="form-item">
          <span class="form-label require" style="padding-top: 6px">定向包名称：</span>
          <el-form-item prop="targetingName">
            <div class="form-value">
              <el-input
                @input="changeTargetingName"
                type="text"
                placeholder="请填写"
                maxlength="50"
                show-word-limit
                style="width: 280px"
                v-model="formData.targetingName"
              ></el-input>
            </div>
          </el-form-item>
        </li>
      </ul>
    </el-form>
  </div>
</template>

<script>
import { getTargetingTags } from "@/api/promotion-gdt.js";
import { mapState } from "vuex";
import { transferActionList, getAgeList, ageList, iosVersionList, androidVersionList } from "../common/config";
export default {
  components: {},
  data() {
    return {
      ageList,
      iosVersionList,
      androidVersionList,
      transferActionList,
      getAgeList,
      formData: {
        districtMode: "UNLIMIT",
        geoLocations: {
          locationTypes: ["LIVE_IN"],
          transFormRegions: [],
          regions: [],
        },
        gender: "GENDER_UNLIMITED",
        ageMode: "UNLIMIT",
        age: {
          min: 14,
          max: 65,
        },
        userOsMode: "UNLIMIT",
        userOs: [],
        appInstallStatus: "UNLIMIT",
        // OPTIMIZATIONGOAL_NONE
        excludedConvertedAudience: {
          excludedDimension: "UNLIMIT",
          conversionBehaviorList: "",
        },
        isCustomTransAction: true,
        targetingName: "新建定向包1",
        networkType: [],
        wxReMarketingMode: [],
        wechatAdBehavior: {
          actions: [],
          excludedActions: [],
        },
      },
      isCpmCustom: false,
      rules: {
        geoLocations: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value.locationTypes?.length === 0) {
                callback(new Error("请选择至少一种人群类型"));
              } else if (value.transFormRegions?.length === 0) {
                callback(new Error("请选择地区"));
              } else {
                callback();
              }
            },
          },
        ],
        conversionBehaviorList: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (
                this.formData.networkType.length > 0 &&
                this.formData.isCustomTransAction &&
                !this.formData.excludedConvertedAudience.conversionBehaviorList
              ) {
                callback(new Error("请选择自定义转化行为"));
              } else {
                callback();
              }
            },
          },
        ],
        targetingName: [
          {
            required: true,
            message: "请输入定向包名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      isIncludesWxSite: false,
      curPrice: 1,
      regionOptions: [],
      saveLoading: false,
    };
  },
  methods: {
    // 获取地理位置列表
    getCountryList() {
      getTargetingTags({
        accountIds: this.advertiserIdList,
        type: "REGION",
        mode: "COMMON",
      }).then((res) => {
        this.regionOptions = res.data.map((item) => {
          item.children?.map((child) => {
            if (child.children && child.children.length === 0) {
              delete child.children;
            }
            return child;
          });
          return item;
        });
      });
    },
    changeTargetingName() {
      this.$emit("changeTargetingName", this.formData);
    },
    //  修改排除已转化用户
    changeExcludedDimension() {},
    formatData() {
      let data = JSON.parse(JSON.stringify(this.formData));
      for (let [key] of Object.entries(data)) {
        if (data[key] === "") {
          delete data[key];
        }
      }
      return data;
    },
    checkData() {
      return Promise.all([this.checkCurData()]);
    },
    checkCurData() {
      this.$emit("changeTargetingName", this.formData);
      return Promise.all([
        new Promise((resolve, reject) => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    fillData(dataItem) {
      this.formData = JSON.parse(JSON.stringify(dataItem));
      const { districtMode, ageMode, wxReMarketingMode, userOsMode, userOs } = dataItem;
      //地区
      if (districtMode === "CITY") {
        this.formData.geoLocations = {
          locationTypes: dataItem.geoLocations.locationTypes,
          transFormRegions: dataItem.geoLocations.transFormRegions,
          regions: dataItem.geoLocations.regions,
        };
      } else {
        this.formData.geoLocations = {
          locationTypes: ["LIVE_IN"],
          transFormRegions: [],
          regions: [],
        };
      }
      if (ageMode === "UNLIMIT") {
        this.formData.age = {
          min: 14,
          max: 65,
        };
      }
      this.formData.gender = dataItem.gender ? dataItem.gender : "GENDER_UNLIMITED";
      this.formData.userOs = userOsMode === "UNLIMIT" ? null : userOs;
      this.formData.appInstallStatus = dataItem.appInstallStatus ? dataItem.appInstallStatus : "UNLIMIT";
      this.formData.networkType = dataItem.networkType ? dataItem.networkType : [];
      this.unNetworkType = dataItem.networkType ? true : false;

      if (wxReMarketingMode === "UNLIMIT" || wxReMarketingMode.length === 0) {
        this.formData.wechatAdBehavior = {
          actions: [],
          excludedActions: [],
        };
        this.formData.wxReMarketingMode = [];
      }
      this.formData.excludedConvertedAudience.excludedDimension = dataItem.excludedConvertedAudience?.excludedDimension
        ? dataItem.excludedConvertedAudience.excludedDimension
        : "UNLIMIT";
      this.formData.excludedConvertedAudience.conversionBehaviorList = dataItem.excludedConvertedAudience?.conversionBehaviorList
        ? dataItem.excludedConvertedAudience.conversionBehaviorList
        : "";
    },
    noSelect(field) {
      this.formData[field] = [];
    },
    clearCustomMediaList() {
      if (this.$refs.customFlowRef) {
        this.$refs.customFlowRef.clearAllList();
      }
    },
    // 子级全选则传父级, 子级未全选则传子级
    handlerExpand() {
      this.$nextTick(() => {
        var arr = [];
        let CheckedNodes = this.$refs.areaCascader.getCheckedNodes();
        CheckedNodes = CheckedNodes.filter((option) => !(option.parent && option.parent.checked));
        for (let index = 0; index < CheckedNodes.length; index++) {
          arr.push(CheckedNodes[index].value);
        }
        this.$set(this.formData.geoLocations, "regions", arr);
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount,
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      draftAdset: (state) => state.PromotionGdt.draft_adset,
      draft_budgets: (state) => state.PromotionGdt.draft_budgets,
      promotedObjectType: (state) => state.PromotionGdt.promotedObjectType,
    }),
    unNetworkType: {
      get() {
        return this.formData.networkType?.length === 0 ? true : false;
      },
      set() {},
    },
    unwxReMarketing: {
      get() {
        return this.formData.wxReMarketingMode.length === 0 ? true : false;
      },
      set() {},
    },
    CpmCustom() {
      return {
        bidMode: this.draft_budgets.bidMode,
        excludedDimension: this.formData.excludedConvertedAudience.excludedDimension,
      };
    },
    isQQShop() {
      return (
        this.draftAdset.placement &&
        this.draftAdset.placement.siteSet?.length === 1 &&
        this.draftAdset.placement.siteSet[0] === "SITE_SET_QQSHOPPING"
      );
    },
  },
  watch: {
    promotedObjectType() {
      this.formData.userOsMode = "UNLIMIT";
      this.formData.userOs = [];
    },
    advertiserIdList: {
      handler(value) {
        if (value) {
          this.getCountryList();
        }
      },
      immediate: true,
    },
    "formData.age": {
      handler(val) {
        const { min, max } = val || {};
        if (min === 14 && max === 18) {
          this.formData.ageMode = "AGE_BETWEEN_14_18";
        } else if (min === 19 && max === 24) {
          this.formData.ageMode = "AGE_BETWEEN_19_24";
        } else if (min === 25 && max === 29) {
          this.formData.ageMode = "AGE_BETWEEN_25_29";
        } else if (min === 30 && max === 39) {
          this.formData.ageMode = "AGE_BETWEEN_30_39";
        } else if (min === 40 && max === 49) {
          this.formData.ageMode = "AGE_BETWEEN_40_49";
        }
      },
      immediate: true,
      deep: true,
    },
    "draftAdset.placement": {
      handler(newV, oldV) {
        if (!(newV?.siteSet.length === oldV?.siteSet.length && newV?.siteSet.sort().toString() === oldV?.siteSet.sort().toString())) {
          const { siteSet } = newV;
          this.formData.wxReMarketingMode = [];
          this.formData.wechatAdBehavior = {
            actions: [],
            excludedActions: [],
          };
          if (siteSet.includes("SITE_SET_WECHAT") || siteSet.includes("SITE_SET_MINI_GAME_WECHAT")) {
            this.isIncludesWxSite = true;
            this.formData.geoLocations.locationTypes = [];
            this.formData.geoLocations.transFormRegions = [];
            this.formData.geoLocations.regions = [];
          } else {
            this.isIncludesWxSite = false;
          }
        }
      },
    },
    CpmCustom: {
      handler(val) {
        if (val.bidMode === "CPM" && val.excludedDimension !== "UNLIMIT") {
          this.formData.isCustomTransAction = true;
          this.isCpmCustom = true;
        } else {
          this.isCpmCustom = false;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.newdirect-wrap {
  box-sizing: border-box;
  padding-top: 10px;
  .modal-form {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      margin-bottom: 20px;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 114px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        // padding-top: 6px;
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(0, 0, 0, 0.65);
        }
        .brand-transfer {
          margin-top: 10px;
          /deep/ .el-transfer-panel {
            width: 180px;
            height: 300px;
          }
        }
        .region-select-wrap {
          padding-top: 10px;
          .region-content {
            margin-top: 10px;
            .cascader-wrap {
              width: 100%;
            }
          }
        }
        .interest-wrap {
          margin-top: 10px;
          .wrap-header {
            display: flex;
            align-items: center;
            .header-text {
              margin: 0 5px 0 12px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
            }
          }
          .transfer-wrap {
            .transfer-title {
              display: block;
              padding: 10px 6px 6px 0;
              font-size: 12px;
              font-weight: bold;
            }
          }
        }
        .custom-wrap {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
